import { PermissionModel } from './permission.model';

/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen., Ryan Duffy & Warren Dowey
 */

export class RolePermissionDetailsModel {
  private _roleId?: string;
  private _permissionId?: string;
  private _permissionDetails?: PermissionModel;
  private _isEnabled?: boolean;

  constructor(
    roleId?: string,
    permissionId?: string,
    permissionDetails?: PermissionModel,
    isEnabled?: boolean
  ) {
    this._roleId = roleId;
    this._permissionId = permissionId;
    this._permissionDetails = new PermissionModel();
    if (permissionDetails) {
      this._permissionDetails = this._permissionDetails.fromJson(permissionDetails);
    }
    this._isEnabled = isEnabled;
  }
  get roleId(): string {
    return this._roleId;
  }

  set roleId(value: string) {
    this._roleId = value;
  }

  get permissionId(): string {
    return this._permissionId;
  }

  set permissionId(value: string) {
    this._permissionId = value;
  }
  get permissionDetails(): PermissionModel {
    return this._permissionDetails;
  }

  set permissionDetails(value: PermissionModel) {
    this._permissionDetails = value;
  }

  get isEnabled(): boolean {
    return this._isEnabled;
  }

  set isEnabled(value: boolean) {
    this._isEnabled = value;
  }

  toJson(): Object {
    const object = {
      role_id: this.roleId,
      permission_id: this.permissionId,
      permission_details: this.permissionDetails,
      is_enabled: this.isEnabled,
    };
    Object.keys(object).forEach((k) => !object[k] && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any): RolePermissionDetailsModel {
    return new RolePermissionDetailsModel(
      input['role_id'],
      input['permission_id'],
      input['permission_details'],
      input['is_enabled']
    );
  }
}
